<template>
  <div>
    <van-row class="bg-white m-t-04 p-t-10 p-b-075">
      <p class="title f-s-09 p-l-05 m-b-10">课程老师</p>
      <van-col :span="24">
        <van-row v-for="item in teacherList" :key="item.tid" class="m-t-05">
          <van-col class="p-l-05 text-c" span="4">
            <van-image :src="item.turl" width="1.7rem" height="1.7rem" round />
          </van-col>
          <van-col :span="20" class="p-r-1">
            <p class="f-s-16 teacherName">{{ item.tname }}</p>
            <p class="f-s-7" style="color: #657081">{{ item.tcontent }}</p>
          </van-col>
        </van-row>
      </van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      teacherList: [],
    };
  },
  created() {
    this.getTeacherList();
  },
  methods: {
    getTeacherList() {
      let data = {
        cid: this.$route.query.cid,
      };
      this.Api({
        url: "api/course/getTeachers",
        method: "POST",
        data,
      }).then((res) => {
        this.teacherList = res.data;
      });
    },
  },
};
</script>

<style scoped>
.teacherName {
  color: #f89d45;
}
</style>